function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 137215",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g99br4ybja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117118",
    style: {
      fill: "#202020"
    },
    d: "M0 0h52.411v39.535H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137205",
    transform: "translate(1.794 8.234)",
    style: {
      clipPath: "url(#g99br4ybja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121139",
    d: "m66.053.5-.771.47q-.1.063-.2.13c-1.907 1.294-7.7 4.436-9.864 3.635-9.581-3.545-19.695 6.465-19.769 6.193a18.534 18.534 0 0 0-2.583 2.5.873.873 0 0 0 .2 1.338c1.614.913 4.782 1.139 5.693.639a18.08 18.08 0 0 0 3.042-1.941c1.713-1.357 2.639-1.421 4.653-1.381.589.011 1.848 1.06 1.848 1.06a10.3 10.3 0 0 0 5.551 8.125l3.827 8.337 1.593-.972c1.448-1.317 3.354-.925 6.542-7.954 1.316-2.9 4.053-4.069 6.3-5.422z",
    transform: "translate(-19.704 -.304)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121140",
    d: "m30.514 56.169-3.254 1.986a2.309 2.309 0 0 1-3.173-.768l-.015-.026a2.308 2.308 0 0 1 .768-3.172l3.254-1.989a2.308 2.308 0 0 1 3.172.768l.015.026a2.308 2.308 0 0 1-.768 3.172",
    transform: "translate(-14.327 -31.308)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121141",
    d: "m36.782 65.025-5.238 3.2a2.308 2.308 0 0 1-3.172-.768l-.015-.025a2.308 2.308 0 0 1 .768-3.173l5.238-3.2a2.308 2.308 0 0 1 3.172.768l.015.026a2.308 2.308 0 0 1-.768 3.172",
    transform: "translate(-16.913 -36.654)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121142",
    d: "m46.5 72.58-6.335 3.865A2.308 2.308 0 0 1 37 75.677l-.015-.025a2.309 2.309 0 0 1 .768-3.173l6.335-3.865a2.308 2.308 0 0 1 3.172.768l.015.026a2.308 2.308 0 0 1-.775 3.172",
    transform: "translate(-22.119 -41.215)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121143",
    d: "m52.322 87.455-1.978 1.207a2.308 2.308 0 0 1-3.172-.768l-.016-.026a2.308 2.308 0 0 1 .769-3.172l1.975-1.207a2.308 2.308 0 0 1 3.172.769l.015.025a2.308 2.308 0 0 1-.768 3.172",
    transform: "translate(-28.262 -50.194)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121144",
    d: "M58.954 82.751a3.16 3.16 0 0 1-.331-.017 2.487 2.487 0 0 1-1.893-1.144l-3.969-6.5a.991.991 0 1 1 1.692-1.032l3.969 6.5a.554.554 0 0 0 .413.2 1.549 1.549 0 0 0 .939-.243l.526-.315c.565-.344.814-.92.652-1.185L58.553 75.2a.991.991 0 0 1 1.678-1.054l2.4 3.824a2.942 2.942 0 0 1-1.305 3.92l-.522.319a3.584 3.584 0 0 1-1.852.539",
    transform: "translate(-31.761 -44.415)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121145",
    d: "M50.273 88.031a2.233 2.233 0 0 1-1.951-1.018l-3.15-5.163a.991.991 0 1 1 1.692-1.032l3.15 5.163c.044.072.379.154.773-.087l.409-.25a.983.983 0 0 0 .412-.459.26.26 0 0 0 .019-.185L49.8 81.823a.991.991 0 0 1 1.718-.988l1.813 3.152a2.17 2.17 0 0 1 .129 1.9 2.95 2.95 0 0 1-1.233 1.45l-.409.249a2.981 2.981 0 0 1-1.546.445",
    transform: "translate(-27.18 -48.496)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121146",
    d: "M72.254 76.776h-.082a2.195 2.195 0 0 1-1.877-.992l-1.987-3.255A.991.991 0 1 1 70 71.5l1.986 3.255a1.47 1.47 0 0 0 1.217-.259l.522-.318c.61-.372.809-.857.781-.978l-2.229-3.537a.991.991 0 0 1 1.678-1.063l2.245 3.566c.706 1.158.071 2.778-1.44 3.7l-.522.319a3.875 3.875 0 0 1-1.981.592",
    transform: "translate(-41.147 -41.132)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121147",
    d: "M79.986 52.433a3.128 3.128 0 0 1-.46-.034 2.669 2.669 0 0 1-1.907-1.225L74.8 46.55a.991.991 0 1 1 1.692-1.032l2.822 4.625a.706.706 0 0 0 .507.3 1.405 1.405 0 0 0 .92-.211l.522-.319a1.409 1.409 0 0 0 .609-.722.706.706 0 0 0-.032-.586.554.554 0 0 1-.03-.053l-7.525-14.236a.991.991 0 0 1 1.752-.926l7.51 14.21a2.673 2.673 0 0 1 .2 2.226 3.377 3.377 0 0 1-1.455 1.774l-.522.319a3.441 3.441 0 0 1-1.785.513",
    transform: "translate(-44.773 -19.837)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121148",
    d: "M8.27 20.344a.989.989 0 0 1-.812-.422l-2.1-3-4.9-3.14A.991.991 0 0 1 .2 12.358L9.14.4a.954.954 0 0 1 .8-.4.99.99 0 0 1 .794.4 7.636 7.636 0 0 0 3.618 2.244c.274.055 1.8.07 2.806.08a19.4 19.4 0 0 1 3.394.16c.848.233 1.55.451 2.169.644 2.179.678 3.081.959 5.413.356a.991.991 0 0 1 .5 1.919c-2.878.744-4.24.32-6.5-.382-.6-.188-1.29-.4-2.106-.625-.3-.064-1.858-.079-2.888-.089a17.2 17.2 0 0 1-3.378-.17 10.4 10.4 0 0 1-3.721-2.031L2.422 12.692l4.167 2.671a.989.989 0 0 1 .276.265l2.215 3.156a.991.991 0 0 1-.81 1.56",
    style: {
      fill: "#202020"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriendly);
export default __webpack_public_path__ + "static/media/icon_friendly.aae65d22b73f3ca03e8b90b5a26ddd3e.svg";
export { ForwardRef as ReactComponent };